export interface ParsedAnalysisResponse {
  status: 'needs_repair' | 'clean';
  summary: string;
  findings: string[];
}

export const parseAnalysisResponse = (
  content: string
): ParsedAnalysisResponse => {
  try {
    const parsed = JSON.parse(content) as {
      status?: unknown;
      summary?: unknown;
      findings?: unknown;
    };

    const status =
      parsed.status === 'needs_repair' || parsed.status === 'clean'
        ? parsed.status
        : 'needs_repair';

    const summary =
      typeof parsed.summary === 'string' && parsed.summary.trim()
        ? parsed.summary.trim()
        : 'Analisi completata.';

    const findings = Array.isArray(parsed.findings)
      ? parsed.findings
          .filter((item): item is string => typeof item === 'string')
          .map(item => item.trim())
          .filter(Boolean)
      : [];

    return { status, summary, findings };
  } catch {
    return {
      status: 'needs_repair',
      summary: 'Risposta non parsabile; problemi rilevati localmente.',
      findings: [],
    };
  }
};
